module.exports = __webpack_public_path__ + "static/bg-2da095d5456e762b74d1861e9b3b00db.jpg";